import { render, staticRenderFns } from "./ProductComparison.vue?vue&type=template&id=c0088ade&scoped=true"
import script from "./ProductComparison.vue?vue&type=script&lang=js"
export * from "./ProductComparison.vue?vue&type=script&lang=js"
import style0 from "./ProductComparison.vue?vue&type=style&index=0&id=c0088ade&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0088ade",
  null
  
)

export default component.exports